import { Directive, Input, OnChanges, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { PermissionService, ModuleGroup } from '../../services/permission.service';

type AnchorInput = number | ModuleGroup | Array<number | ModuleGroup> | null | undefined;

type AnchorMode = 'any' | 'all';

@Directive({
  selector: '[appHasAnchor]'
})
export class HasAnchorDirective implements OnChanges, OnDestroy {
  @Input('appHasAnchor') requiredAnchor: AnchorInput = null;
  @Input() appHasAnchorMode: AnchorMode = 'any';

  private hasView = false;
  private groupsSub?: Subscription;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionService
  ) {
    // Reavaliar automaticamente quando os grupos do usuário forem atualizados.
    this.groupsSub = this.permissionService.userGroups$.subscribe(() => {
      this.updateView();
    });
  }

  ngOnChanges(): void {
    this.updateView();
  }

  private updateView(): void {
    const required = this.requiredAnchor;

    // Sem requisito => não restringe (não bloqueia UX).
    if (required === null || required === undefined) {
      this.show();
      return;
    }

    const requiredList = Array.isArray(required) ? required : [required];

    const hasAccess =
      this.appHasAnchorMode === 'all'
        ? this.permissionService.hasAllAnchors(requiredList)
        : this.permissionService.hasAnyAnchor(requiredList);

    if (hasAccess) {
      this.show();
    } else {
      this.hide();
    }
  }

  private show(): void {
    if (this.hasView) return;
    this.viewContainer.createEmbeddedView(this.templateRef);
    this.hasView = true;
  }

  private hide(): void {
    if (!this.hasView) return;
    this.viewContainer.clear();
    this.hasView = false;
  }

  ngOnDestroy(): void {
    this.groupsSub?.unsubscribe();
  }
}
